import React from "react";
import ReactDOM from "react-dom/client";
import 'select2/dist/js/select2.min.js';
import { App } from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.scss";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
